var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1a5fc2da8567fe5f22a54080c8eacff2a927369b"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["linktracker@z5-internet-ltd"]={id:"1a5fc2da8567fe5f22a54080c8eacff2a927369b"};
      